module.exports = __webpack_public_path__ + "img/Ill_Skill Details_Progress.e30f233e.svg";